import React from 'react';
import { useFormikContext } from 'formik';

import { useStyles } from '~/assets/styles';
import Grid from '~/components/core/Atomic/Grid/Grid';
import TextFieldFormik from '~/components/TextFieldFormik';

import { AGENCY_ID_OVERRIDE_FIELD_ID } from '../../constants';

const AgencyIdOverride = () => {
  const { classes } = useStyles();
  const { isSubmitting } = useFormikContext();

  return (
    <Grid container>
      <Grid item xs={6}>
        <TextFieldFormik
          id={AGENCY_ID_OVERRIDE_FIELD_ID}
          label="Override Agency ID"
          className={classes.textField}
          disabled={isSubmitting}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default AgencyIdOverride;
